import { useState, useContext, useEffect, useRef } from 'react';
import ApiContext from 'src/provider/API/call-service';
import utility from 'src/utils/utility'
import { CustomContainer, ScreenContainer } from 'src/style';
import { ReportFilter, ServerSideTable } from 'src/component';
import helpers from 'src/utils/helpers';
import { crossBorderPaymentColumns, transferReportColumn, transferReportData } from 'src/utils/tableLayout';
import { useTranslation } from "react-i18next"


const CrossBorderReport = () => {
    const {API, downloadReport} = useContext(ApiContext)
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [showFilter, setShowFilter] = useState<boolean>(false)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const { t } = useTranslation()

    const filterDataRef = useRef({})
    


    useEffect(() => {
        filterDataRef.current = {}
        fetchCBPReport()
    }, [])

    async function fetchCBPReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const response = await API.cbpTransactionReport(pageNumber, pageSize, {...filterDataRef.current, returnMax: isDownload})
        if (response) {
            if (isDownload) {
                return downloadReport(response, t('report.cbp.downloadFileName'))
            }
            setReportData(response)
            setReport(helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize}))
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        fetchCBPReport()
        setResetPagination(!resetPagination)
    }

    return (
        <>
            <ScreenContainer>
                <CustomContainer topMargin='3'>
                    <ServerSideTable
                        tableData={report}
                        tableColumns={crossBorderPaymentColumns(t)} 
                        dataFetchMethod={fetchCBPReport}
                        totalRows={reportData?.total}
                        tableTitle={t('report.cbp.tableTitle')}
                        customStyle
                        shouldResetPagination={resetPagination}
                        //canSearch
                        canFilter={() => setShowFilter(true)}
                        canClear={handleClear}
                        downloadAction={() => fetchCBPReport(1, 10, true)}
                    />
                </CustomContainer>
            </ScreenContainer>
            { showFilter &&
                <ReportFilter
                    type='cbp-report'
                    onApplyFilter={fetchCBPReport}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setShowFilter(false)}
                />
            }
        </>
    )
}

export default utility.routeData('cross-border-report', 'Cross Border Report', <CrossBorderReport/>)